import { DateTime } from "luxon";

import "../../../assets/scss/ActivityFeed.scss";
import { Button, Col, Row } from "react-bootstrap";

import { ActivityFeedElement } from "../../../_services/mocks/MockActivityFeedProvider";
import Agenda from "../../../assets/svg/Agenda";

type ActivityFeedProps = {
  feed: ActivityFeedElement[];
};

export const MyOrdersDetailsActivityFeedComponent = ({
  feed,
}: ActivityFeedProps) => {
  const feedIcon = (type: string) => {
    switch (type) {
      case "Attente Locataire":
      case "Rappel 1":
      case "Rappel 2":
        return (
          <div className="activity-feed-icon">
            <i
              className="bi bi-chat-left-text"
              style={{ color: "#000d5b" }}
            ></i>
          </div>
        );
      case "Planifié":
        return (
          <div className="activity-feed-icon">
            <Agenda color="#000d5b" w="16" />
          </div>
        );
      case "Non intervenu":
        return (
          <div className="activity-feed-icon">
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="#000d5b"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M13.5316 0.407036C12.9889 -0.135679 12.1065 -0.135679 11.5637 0.407036L6.96931 5.00146L2.37489 0.407036C1.83218 -0.135679 0.949749 -0.135679 0.407035 0.407036C-0.135678 0.94975 -0.135678 1.83218 0.407035 2.37489L5.00146 6.96932L0.407035 11.5637C-0.135678 12.1065 -0.135678 12.9889 0.407035 13.5316C0.949749 14.0743 1.83218 14.0743 2.37489 13.5316L6.96931 8.93718L11.5637 13.5316C12.1065 14.0743 12.9889 14.0743 13.5316 13.5316C14.0743 12.9889 14.0743 12.1065 13.5316 11.5637L8.93717 6.96932L13.5316 2.37489C14.0743 1.83218 14.0743 0.94975 13.5316 0.407036Z" />
            </svg>
          </div>
        );
      case "Intervenu":
        return (
          <div className="activity-feed-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="#000d5b"
              viewBox="0 0 16 16"
            >
              <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z" />
              <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z" />
            </svg>
          </div>
        );

      default:
        return "";
    }
  };

  const giveMeAFeedText = (type: string, additionnalInfo?: any) => {
    const date = additionnalInfo as Date;
    switch (type) {
      case "Attente Locataire":
        return "SMS de prise de rendez-vous envoyé a l'occupant.";
      case "Rappel 1":
        return "SMS de rappel pour la  prise de rendez-vous envoyé a l'occupant.";
      case "Rappel 2":
        return "2ème SMS de rappel pour la  prise de rendez-vous envoyé a l'occupant.";
      case "Planifié":
        return (
          "Rendez-vous planifié le " +
          date.getDay() +
          "/" +
          date.getMonth() +
          "/" +
          date.getFullYear() +
          " à " +
          date.getHours() +
          ":" +
          date.getMinutes()
        );
      case "Non intervenu":
        return "L’opérateur n’est pas encore intervenu.";
      case "Intervenu":
        return "L’opérateur est intervenu.";
      default:
        return "notification";
    }
  };

  return (
    <div className="d-flex flex-column justify-content-between me-4 ms-3">
      <div>
        <Row className="activity-feed-header px-2">
          <Col xs={10} className="activity-feed-title">
            Flux d'activité
          </Col>

          <Col xs={2}>
            <Button size="lg" variant="link">
              <i className="bi bi-arrow-repeat arrow-dashboard"></i>
            </Button>
          </Col>
        </Row>

        <div>
          {feed.map((step, index) => (
            <div className="position-relative" key={index.toString()}>
              <div className="position-absolute h-100 line-dashboard"></div>
              <div className="w-100 d-flex">
                <div className="d-flex align-items-center pt-3 feed-icon">
                  {feedIcon(step.type)}
                </div>
                <div className="activity-feed-text mt-3 w-100 fw-bolder">
                  <Button className="activityFeedButton pe-none" variant="none">
                    {giveMeAFeedText(step.type, step.additionnalInfo)}
                  </Button>
                </div>
              </div>
              <Row className="activity-feed-date pb-2 mt-1 d-flex justify-content-end">
                {DateTime.fromJSDate(step.time).startOf("day") >=
                DateTime.now().startOf("day")
                  ? DateTime.fromJSDate(step.time).toFormat("T")
                  : DateTime.fromJSDate(step.time).toRelativeCalendar()}
              </Row>
            </div>
          ))}
        </div>
      </div>
      <Button variant="outline-primary" className="mt-4 ms-4 btn-nunito">
        Afficher plus
      </Button>
    </div>
  );
};
